import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './ReduxStore/index';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandlerUI from './helpers/ErrorHandlerUI';
import App from './App';
// import { httpClient } from './HttpClient';
// import keycloak from './KeycloakIntegration';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Import Open Sans font
import './index.css'; // Add Open Sans import in your CSS file, see below
import AuthorizationHandler from './utils/Authorizarion';

// Create a theme with Open Sans as the default font
const theme = createTheme({
    typography: {
        fontFamily: "'Open Sans', sans-serif",
    },
});


// Function to log errors (could be extended to send to an external service)
function logErrorToService(error, info) {
    console.info("Logged Error:", error, "Info:", info);
}

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <Provider store={store}>
            <ErrorBoundary FallbackComponent={ErrorHandlerUI}
                onError={logErrorToService}
                onReset={() => window.location.reload()}>
                <AuthorizationHandler>
                    <App />
                </AuthorizationHandler>
            </ErrorBoundary>
        </Provider>
    </ThemeProvider>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();


// Function to get user info from the API
// const fetchUserInfo = async () => {
//     try {
//         const response = await httpClient.get(`${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/userinfo`);
//         console.log('User Info from API', response.data);
//     } catch (error) {
//         console.error('Failed to fetch user info', error);
//     }
// };
// const fetchKeycloack = async () => {
//     console.log('function running -------');
//     try {
//         const response = await httpClient.get(`https://asset-management.esakha.tatamotors.com/keycloak.json`);
//         console.log('fetchKeycloack from API', response.data);
//     } catch (error) {
//         console.error('Failed to fetch user info', error);
//     }
// };

// fetchKeycloack();

// // Initialize Keycloak
// keycloak.init({
//     onLoad: 'login-required',
//     checkLoginIframe: false,  // Enables checking the session in an iframe
//     promiseType: 'native',
//     enableLogging: true,
// }).then(authenticated => {
//     if (authenticated) {
//         // console.info("Authenticated");

//         // Log Keycloak instance and token
//         // console.log('Keycloak', keycloak);
//         // console.log('Access Token', keycloak.token);

//         // Retrieve and log user information from Keycloak
//         const userInfo = keycloak.tokenParsed;
//         // console.log('User Info', userInfo);

//         // Set the Authorization header for httpClient
//         httpClient.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;

//         // Fetch additional user info from the API
//         fetchUserInfo();

//         // Set up a token refresh interval to ensure the token is always valid
//         setInterval(() => {
//             keycloak.updateToken(70).then(refreshed => {
//                 if (refreshed) {
//                     // console.info('Token refreshed');
//                     fetchUserInfo();
//                     httpClient.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;
//                 } else {
//                     // console.warn('Token is still valid');
//                 }
//             }).catch(() => {
//                 // console.error('Failed to refresh token');
//                 keycloak.login();  // Redirect to login if token cannot be refreshed
//             });
//         }, 60000);  // Check every minute (adjust based on your token TTL)

//         // Render the React app
//         renderApp();

//     } else {
//         keycloak.login();
//         // console.log("Login required");
//     }
// }).catch(error => {
//     console.error('Failed to initialize Keycloak', error);
// });
